import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';

function Wallet() {
  return (
    <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
      <Path
        d="M6.094 4A3.094 3.094 0 003 7.094v9.562a3.094 3.094 0 003.094 3.094h11.812A3.094 3.094 0 0021 16.656V10.47a3.094 3.094 0 00-3.094-3.094H7.22a.842.842 0 00-.844.844c0 .467.376.844.844.844h10.687c.777 0 1.407.629 1.407 1.406v6.187c0 .777-.63 1.407-1.407 1.407H6.094c-.777 0-1.407-.63-1.407-1.407V7.094c0-.777.63-1.407 1.407-1.407H19.03a.842.842 0 00.844-.843.842.842 0 00-.844-.844H6.094zM16.5 14.688a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
        fill={Styles.Colors.PayNew.black01}
      />
    </Svg>
  );
}

const WalletIcon = React.memo(Wallet);

export default WalletIcon;
